(function ($) {

'use strict';

	/**
	 * Create and show a Messi info dialog.
	 * @param {string} title
	 * @param {string} message
	 * @param {int} timeout
	 * @param {string} dlgType 'info' (blue titlebar) | 'anim error' (red animated titlebar) | 'success' (green titlebar)
	 * @param {object} extraMessiOptions
	 * @returns {Messi} dialog
	 */
	$.showMessiInfo = function (title, message, timeout, dlgType, extraMessiOptions) {
		// ensure Messi is loaded
		$.initMessi(function () {
			// check if timeout is a number and in the valid range 1000-20000
			timeout = parseInt(timeout);
			var messiTimeout = (!isNaN(timeout) && timeout > 999 && timeout < 20000 ?
					timeout : 1200);

			const messiBox =  new Messi(message.replace('\\n', '<br />'),
					jQuery.extend({title: title,
						titleClass: (typeof dlgType === 'string' ? dlgType : 'success'),
						autoclose: messiTimeout},
							$.morejs_options.messi.defaultOpt,
							$.morejs_options.messi.position(),
							(extraMessiOptions || {})));
			// WORKAROUND for messi bug: autoclose doesn't trigger callback function, so we have to call it manually
			if (extraMessiOptions && typeof extraMessiOptions.callback === 'function') {
				setTimeout(() => extraMessiOptions.callback(), messiTimeout + 200);
			}
			return messiBox;
		});
	};	// $.showMessiInfo

}(jQuery));